import _ from 'lodash';
import responsiveCompositesDefinition from './compositeDefinitions';
import compositeFactory from '../composites/compositeFactory';

var ResponsiveComposites = _.mapValues(responsiveCompositesDefinition, function (v) {
  return compositeFactory(v);
});

export default ResponsiveComposites;